export interface RoboticsLocation {
  code: string;
  locationId: number;
  name: string;
}

export const ROBOTICS_LOCATIONS: RoboticsLocation[] = [
  { code: "AMOUT", locationId: 46, name: "Utrecht" },
  { code: "ARSAN", locationId: 68, name: "Amsterdam" },
];

export const findRoboticsLocationByCode = (
  code?: string | null
): RoboticsLocation | undefined =>
  code ? ROBOTICS_LOCATIONS.find((l) => l.code === code) : undefined;
